import React, { useEffect } from 'react';
import { Control, useFieldArray, useFormContext } from 'react-hook-form';
import Icon from '@common/assets';
import { defaultResearch } from '@components/profile/profileOverlay/overlays/edu/eduForm/index';
import ResearchesDescription from '@components/profile/profileOverlay/overlays/edu/eduForm/ResearchesDescription';
import ResearchesFiles from '@components/profile/profileOverlay/overlays/edu/eduForm/ResearchesFiles';

import { ProfileEducationFormVO } from '@domain/vo/profile/ProfileEducationFormVO';

import classnames from 'classnames/bind';
import styles from '../edu.module.scss';

const cx = classnames.bind(styles);

interface ResearchProps {
  control: Control<ProfileEducationFormVO>;
}

const Research = ({ control }: ResearchProps) => {
  const { reset, getValues } = useFormContext<ProfileEducationFormVO>();
  const { fields, append } = useFieldArray({
    control,
    name: 'profileResearches',
  });

  useEffect(() => {
    const researches = getValues().profileResearches;
    if (!researches?.length) {
      append(defaultResearch);
    }
  }, []);

  const appendResearch = () => {
    append(defaultResearch);
  };

  const profileResearchEls = fields.map((filed, index) => {
    const deletable = index > 0;

    const handleDelete = () => {
      const form = getValues();
      const researches = form.profileResearches?.filter((_, i) => i !== index);
      form.profileResearches = researches;
      reset(form);
    };

    return (
      <div key={filed.id} className={cx('researchInner')}>
        <span className={cx('writeText')}>연구 분야·논문</span>

        {deletable && (
          <button className={cx('btnResearchDelete')} type="button" onClick={handleDelete}>
            <Icon name="deleteLight" width={20} height={20} />
            삭제
          </button>
        )}
        <ResearchesFiles index={index} control={control} defaultValue={filed.attachFiles} />
        <ResearchesDescription index={index} control={control} defaultValue={filed.description} />
      </div>
    );
  });

  return (
    <div className={cx('researchArea')}>
      {profileResearchEls}

      <a className={cx('btnResearchAdd')} role="button" onClick={appendResearch}>
        <Icon name="addLight" width={24} height={24} />
        연구 분야·논문 추가
      </a>
    </div>
  );
};

export default Research;
